import { Dialog } from "primereact/dialog";
import { MdClose } from "react-icons/md";

import { getLanguage } from "../utils/getLanguage";
import Button from "./Button";

const CustomModal = ({
  isOpen,
  onClose,
  footer,
  children,
  isFullScreen = false,
  outScroll = false,
  className,
  contentClassname,
  withCloseButton = true,
}) => {
  const lang = getLanguage();

  return (
    <Dialog
      modal
      visible={isOpen}
      onHide={onClose}
      footer={footer}
      header={null}
      resizable={false}
      draggable={false}
      closable={false}
      pt={{
        header: { className: "hidden" },
        content: `py-4 ${outScroll && "overflow-y-visible"} ${contentClassname} rounded-[40px]`,
        footer: "bg-[#F8FAFC] dark:bg-[#1B2535] pt-3 pb-3 border-t border-border dark:border-dark-border",
      }}
      className={`w-full ${isFullScreen ? "h-full max-w-[90%]" : "max-w-[38rem]"} rounded-[40px] bg-white shadow-xl dark:bg-dark-surface ${className}`}
    >
      {withCloseButton && (
        <Button
          onClick={onClose}
          color="white"
          icon={<MdClose size="22" />}
          className={`absolute z-50 !p-1 ${lang === "ar" ? "left-2" : "right-2"} top-1 transition-all duration-300 hover:scale-105 dark:border-dark-border`}
        />
      )}
      {children}
    </Dialog>
  );
};

export default CustomModal;
